import { render, staticRenderFns } from "./DefectNoticeView.vue?vue&type=template&id=03e4133b&"
import script from "./DefectNoticeView.vue?vue&type=script&lang=ts&"
export * from "./DefectNoticeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports